module.exports = __webpack_public_path__ + "static/img/ch_bcg3.d576268e.png";